import { QuestionCircleOutlined } from '@ant-design/icons'
import type { FormProps } from 'antd'
import { Button, Checkbox, Col, Form, Input, Row, Space, theme, Typography } from 'antd'
import InputMask from 'react-input-mask'

const { Text } = Typography

type OrdFormFields = {
    organization: string
    organizationType: string
    companyFullName: string
    subscriberPhoneNumber: string
    IsORS: string
    isRR: string
}

export const OrdForm = () => {
    const onFinish: FormProps<OrdFormFields>['onFinish'] = async (values) => {
        console.log('onFinish', values)
    }

    const [form] = Form.useForm()

    const {
        token: { colorTextLabel }
    } = theme.useToken()

    return (
        <Form form={form} name="add-partner" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} onFinish={onFinish}>
            <Row gutter={16}>
                <Col span={8}>
                    <Form.Item
                        label={
                            <Space>
                                <Text style={{ color: colorTextLabel }}>Организация</Text>
                                <QuestionCircleOutlined />
                            </Space>
                        }
                        name="organization"
                        required={false}
                    >
                        <Input placeholder="Введите название организации" />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={8}>
                    <Form.Item
                        label="Тип организации"
                        name="organizationType"
                        rules={[{ required: true, message: 'Обязательное поле' }]}
                    >
                        <Input placeholder="Юридическое лицо" />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={8}>
                    <Form.Item
                        label={
                            <Space>
                                <Text style={{ color: colorTextLabel }}>ОПФ и полное наименование компании</Text>
                                <QuestionCircleOutlined />
                            </Space>
                        }
                        name="companyFullName"
                        required={false}
                    >
                        <Input placeholder="Введите ОФП" />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={8}>
                    <Form.Item
                        label={
                            <Space>
                                <Text style={{ color: colorTextLabel }}>Абонентский номер телефона</Text>
                                <QuestionCircleOutlined />
                            </Space>
                        }
                        name="subscriberPhoneNumber"
                        required={false}
                    >
                        <InputMask mask="+7(999)999-99-99" maskChar={null}>
                            {(inputProps) => <Input {...inputProps} placeholder="Введите номер телефона" />}
                        </InputMask>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={4}>
                    <Form.Item name="IsORS">
                        <Checkbox>
                            <Space>
                                <Text style={{ color: colorTextLabel }}>Является ОРС</Text>
                                <QuestionCircleOutlined />
                            </Space>
                        </Checkbox>
                    </Form.Item>
                </Col>
                <Col span={4}>
                    <Form.Item name="isRR">
                        <Checkbox>
                            <Space>
                                <Text style={{ color: colorTextLabel }}>Является РР</Text>
                                <QuestionCircleOutlined />
                            </Space>
                        </Checkbox>
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={4}>
                    <Button type="primary" htmlType="submit">
                        Сохранить изменения
                    </Button>
                </Col>
            </Row>
        </Form>
    )
}
